import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { Button } from '@bliks-io/ui';

/**
 * Der Sprung in das Fremdsystem, in dem der Datensatz wirklich lebt.
 *
 * Ein Anker und kein `navigate`: es verlässt die Anwendung, und ein neuer
 * Reiter lässt die Kontoseite stehen — wer dort etwas nachschlägt, will
 * danach hierher zurück, ohne die Anmeldung neu aufzubauen.
 *
 * `rel="noopener noreferrer"`, weil `target="_blank"` der neuen Seite sonst
 * einen Griff auf diese hier gibt.
 *
 * Rendert nichts ohne Adresse: ein toter Knopf verspricht einen Weg, den es
 * nicht gibt — häufig genau dann, wenn das Fremdsystem gar nicht eingerichtet
 * ist.
 */
export function OpenInSystemButton({
  url,
  label
}: {
  url: string | null | undefined;
  /** Wohin es geht — „HubSpot", „Frisbii". Der Knopf nennt das System. */
  label: string;
}) {
  const { t } = useTranslation();
  if (!url) return null;

  return (
    <Button variant="outline" size="small" asChild>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <ExternalLink className="mr-2 h-4 w-4" />
        {t('accountAdmin.openIn', { system: label })}
      </a>
    </Button>
  );
}
